export const bakes = [
  {
    name: 'The celebration cake',
    category: 'Cakes',
    description: 'Soft vanilla sponge, cloud-like buttercream, and all the little details.',
    detail: 'A classic, made personal. Choose your colours, flavours, and finishing touches and we will bake a cake for your kind of celebration.',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&w=1000&q=85',
    alt: 'A layered celebration cake finished with buttercream',
    className: 'bake-card__image--cake',
    featured: true,
  },
  {
    name: 'Strawberry cloud cake',
    category: 'Cakes',
    description: 'Vanilla sponge, fresh berries, and a soft swirl of cream.',
    detail: 'Light vanilla layers meet fresh strawberries and softly whipped cream. A lovely centrepiece for sunny afternoons and happy birthdays.',
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=1000&q=85',
    alt: 'A strawberry-topped cake with layers of cream',
  },
  {
    name: 'Little party cupcakes',
    category: 'Cakes',
    description: 'A joyful box of soft sponge and swirly buttercream.',
    detail: 'Small cakes with all the celebration of a big one. Ask about colours, flavours, and a box sized for your gathering.',
    image: 'https://images.unsplash.com/photo-1519869325930-281384150729?auto=format&fit=crop&w=1000&q=85',
    alt: 'A decorated cupcake with buttercream frosting',
  },
  {
    name: 'Brown butter chocolate chip cookies',
    category: 'Chocolates',
    description: 'Golden edges, soft middles, and pools of chocolate.',
    detail: 'A little nutty from browned butter, a little salty, and full of chocolate. Best shared warm, if you can wait that long.',
    image: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?auto=format&fit=crop&w=1000&q=85',
    alt: 'Freshly baked chocolate chip cookies',
    className: 'bake-card__image--cookies',
    featured: true,
  },
  {
    name: 'Jammy thumbprint cookies',
    category: 'Cookies',
    description: 'Buttery little cookies with a bright berry middle.',
    detail: 'Tender, buttery cookies with a spoonful of berry jam tucked into the middle. A colourful addition to a treat box or afternoon tea.',
    image: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?auto=format&fit=crop&w=1000&q=85',
    alt: 'A small batch of golden homemade cookies',
  },
  {
    name: 'Vanilla bean shortbread',
    category: 'Cookies',
    description: 'Crumbly, buttery biscuits with a little vanilla warmth.',
    detail: 'A simple, buttery shortbread with real vanilla warmth. A lovely little something alongside a cup of tea or tucked into a gift box.',
    image: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?auto=format&fit=crop&w=1000&q=85',
    alt: 'Golden homemade shortbread cookies',
  },
  {
    name: 'Little lemon loaf',
    category: 'Loaves',
    description: 'Bright, buttery, and finished with a generous lemon drizzle.',
    detail: 'A tender lemon loaf with a sunny citrus glaze. Just right for a cup of tea, a thank-you, or a Tuesday that needs improving.',
    image: 'https://images.unsplash.com/photo-1519915028121-7d3463d20b13?auto=format&fit=crop&w=1000&q=85',
    alt: 'A homemade loaf cake topped with icing',
    className: 'bake-card__image--loaf',
    featured: true,
  },
  {
    name: 'Banana walnut loaf',
    category: 'Loaves',
    description: 'A soft, warmly spiced loaf with a little crunch.',
    detail: 'Ripe bananas make this loaf extra tender, while toasted walnuts add just the right amount of crunch. Lovely sliced thick.',
    image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1000&q=85',
    alt: 'A freshly baked golden loaf',
  },
  {
    name: 'Cinnamon morning buns',
    category: 'Morning bakes',
    description: 'Soft, swirled, cinnamon-scented, and best shared warm.',
    detail: 'Pillowy dough wrapped around cinnamon sugar and finished with a simple glaze. A sweet start for a slow morning or a brunch table.',
    image: 'https://images.unsplash.com/photo-1509365465985-25d11c17e812?auto=format&fit=crop&w=1000&q=85',
    alt: 'Warm cinnamon buns with a sweet glaze',
  },
  {
    name: 'Soft cardamom buns',
    category: 'Morning bakes',
    description: 'Fragrant, gently spiced swirls with a sugar sparkle.',
    detail: 'A soft, buttery bun scented with cardamom and finished with a fine sugar sparkle. Made for slow mornings and second cups of coffee.',
    image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1000&q=85',
    alt: 'Freshly baked breakfast buns',
  },
  {
    name: 'Fudgy brownie squares',
    category: 'Chocolates',
    description: 'Deep chocolate, shiny tops, and wonderfully soft centres.',
    detail: 'Rich, chocolatey brownies with a delicate crackle on top and a soft centre. Ask about adding them to a mixed treat box.',
    image: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?auto=format&fit=crop&w=1000&q=85',
    alt: 'A stack of rich chocolate brownies',
  },
  {
    name: 'A little bit of everything',
    category: 'Treat boxes',
    description: "A mixed box of the kitchen's favourite little treats.",
    detail: 'A happy assortment for sharing, gifting, or keeping close by. Tell us about your occasion and we can suggest a mix.',
    image: 'https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?auto=format&fit=crop&w=1000&q=85',
    alt: 'An assortment of homemade baked treats',
  },
  {
    name: 'The party table box',
    category: 'Treat boxes',
    description: 'A colourful assortment made for passing around.',
    detail: 'A generous mix of cookies, brownies, and other small-batch favourites. Made to order for birthdays, get-togethers, and thank-yous.',
    image: 'https://images.unsplash.com/photo-1558326567-98ae2405596b?auto=format&fit=crop&w=1000&q=85',
    alt: 'A box of assorted cookies and sweets',
  },
];

export const bakeCategories = [
  'All bakes',
  'Cakes',
  'Cookies',
  'Chocolates',
  'Loaves',
  'Morning bakes',
  'Treat boxes',
];

export const bakeCategoryTaglines = {
  Cakes: 'For the days that deserve a candle.',
  Cookies: 'Little comforts, fresh from the oven.',
  Chocolates: 'Chocolate makes you happy.',
  Loaves: 'A slice of the good stuff.',
  'Morning bakes': 'Good mornings start warm.',
  'Treat boxes': 'The more, the merrier.',
};